import {getAppPathFromUrl} from '@toolify/client/src/modules/routes/functions/getAppPathFromUrl'
import {isInternalAppUrl} from '@toolify/client/src/modules/routes/functions/isInternalAppUrl'

export function getInternalHrefPath(
  href: string,
  options: {
    baseHref: string
    currentHost: string
    internalHosts: readonly string[]
  },
): string | null {
  if(!href || href.startsWith('javascript:')) {
    return null
  }
  /**
   * A fragment-only href belongs to whoever rendered it, never to this helper. On mobile the router
   * runs on hash history, so every RouterLink renders `#/@workspace/...`; resolved against the
   * current url that has pathname `/`, and the deep-link mapping below returns `pathname + hash` -
   * `/#/@workspace/...`. The router then reads the path out of that as `/`, whose record is the
   * login view, and a logged-in user landing there is bounced on to the workspace home. That is why
   * opening a file preview in the native app dropped onto the home screen. An absolute url that
   * merely carries a fragment is unaffected and still keeps it.
   */
  if(href.startsWith('#')) {
    return null
  }
  let url: URL
  try {
    url = new URL(href, options.baseHref)
  } catch {
    return null
  }
  if(!isInternalAppUrl(url, options.currentHost, options.internalHosts)) {
    return null
  }
  return getAppPathFromUrl(url)
}
